import { useSelector } from 'react-redux';

export function useImxAuth() {
  const auth = useSelector((state) => state.imxAuth);
  return {
    user: auth.user,
    accessToken: auth.accessToken,
    walletAddress: auth.walletAddress,
    isAuthenticated: !!auth.accessToken,
    isLoading: auth.isLoading,
    error: auth.error,
  };
}